module.exports = __webpack_public_path__ + "static/media/03.8fcc799b.mp3";